import { acceptHMRUpdate, defineStore } from "pinia";
import { reactive, toRefs } from "vue";
import { onBeforeRouteUpdate } from "vue-router";

import { SearchHelper } from "@/helpers";

interface State {
  isOpen: boolean;
}

const initialState = {
  isOpen: false
};

const STORE_ID = "notes";

export const useNotesStore = defineStore(STORE_ID, () => {
  const state = reactive<State>({ ...initialState });

  const open = () => (state.isOpen = true);
  const close = () => (state.isOpen = false);
  const toggle = () => (state.isOpen = !state.isOpen);

  onBeforeRouteUpdate((to, from, next) => {
    // Make sure note state isn't reset when changing metadata.
    if (SearchHelper.hasSearchChanged(from.query, to.query, false)) {
      Object.assign(state, { ...initialState });
    }

    next();
  });

  return {
    ...toRefs(state),
    close,
    open,
    toggle
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useNotesStore, import.meta.hot));
}
